var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SchemaModuleUniversal } from './module-universal';
import * as rawJSONSchemaModuleNeurosurgery from '../../schemas/module-neurosurgery.json';
var SchemaModuleNeurosurgery = (function (_super) {
    __extends(SchemaModuleNeurosurgery, _super);
    function SchemaModuleNeurosurgery() {
        var _this = _super.call(this) || this;
        _this.loadSchema(rawJSONSchemaModuleNeurosurgery);
        return _this;
    }
    return SchemaModuleNeurosurgery;
}(SchemaModuleUniversal));
export { SchemaModuleNeurosurgery };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-neurosurgery.ts.pre-build-optimizer.js